import { type CountryCode } from "libphonenumber-js";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AddressSearch } from "@/components/address-search";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { ENV } from "@/features/config";

import { useAddressFields } from "../../contexts/use-address-fields";

import { type FormControlProps } from "./types";

export const SearchFormControl = ({ name, countryCode }: FormControlProps) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const { fillAddressFields } = useAddressFields();

  return (
    <FormField
      control={control}
      name={name}
      render={() => (
        <FormItem>
          <FormLabel>{t("paymentMethod_searchAddress")}</FormLabel>
          <FormControl>
            <AddressSearch
              locale="en-US"
              apiKey={ENV.LOQATE.KEY || ""}
              countries={[countryCode as CountryCode]}
              debounce={300}
              data-test-id="address-search"
              onSelect={fillAddressFields}
              manualEntryText={t("paymentMethod_enterAddressManually")}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
